module.exports = __webpack_public_path__ + "static/assets/3af83ae195f0c6fa2827b36553221519.svg";